import React from 'react'
import { ElementChoice } from '../game/GameEngine'

interface ElementSelectorProps {
  selected: ElementChoice | null
  onSelect: (choice: ElementChoice) => void
}

// AGC: Element choice selector component
// AGC: Allows players to choose between Fire, Water, Ice, and Wind elements
export const ElementSelector: React.FC<ElementSelectorProps> = ({ selected, onSelect }) => {
  const choices: { type: ElementChoice; emoji: string; name: string; description: string; color: string }[] = [
    {
      type: 'WATER',
      emoji: '💧',
      name: 'Water',
      description: 'Extinguishes Fire',
      color: 'from-blue-500 to-blue-600'
    },
    {
      type: 'FIRE',
      emoji: '🔥',
      name: 'Fire',
      description: 'Melts Ice',
      color: 'from-red-500 to-red-600'
    },
    {
      type: 'ICE',
      emoji: '❄️',
      name: 'Ice',
      description: 'Freezes Wind',
      color: 'from-cyan-400 to-cyan-500'
    },
    {
      type: 'WIND',
      emoji: '💨',
      name: 'Wind',
      description: 'Evaporates Water',
      color: 'from-green-400 to-green-500'
    }
  ]

  return (
    <div className="grid grid-cols-1 gap-3">
      {choices.map((choice) => (
        <button
          key={choice.type}
          onClick={() => onSelect(choice.type)}
          className={`
            origami-button p-4 text-left transition-all duration-200
            ${selected === choice.type 
              ? `bg-gradient-to-r ${choice.color} ring-2 ring-white/50 scale-105` 
              : 'bg-white/10 hover:bg-white/20'
            }
          `}
        >
          <div className="flex items-center space-x-4">
            <span className="text-3xl">{choice.emoji}</span>
            <div>
              <h3 className="font-bold text-white">{choice.name}</h3>
              <p className="text-sm text-gray-300">{choice.description}</p>
            </div>
          </div>
        </button>
      ))}
    </div>
  )
}
